import { $tracing } from '../tracing';

export const mainDeviceDisableFail = (error: any) => {
  $tracing.addEvent({
    t: 'main device disable fail',
    ext: {
      error,
    },
  });
};
